// --- 反馈管理 --- //

export default [
  {
    name: "feedbackList",
    path: "/supplySystem/:supplyId/feedbackManagement/feedbackList",
    meta: { title: "反馈列表" },
    component: require("business/platformManagement/feedbackManagement/feedbackList/list.vue").default
  },
  {
    name: "feedbackDetail",
    path: "/supplySystem/:supplyId/feedbackManagement/feedbackDetail",
    meta: { title: "反馈详情" },
    component: require("business/platformManagement/feedbackManagement/feedbackList/detail.vue").default
  },
  {
    name: "goldIdeaList",
    path: "/supplySystem/:supplyId/feedbackManagement/goldIdeaList",
    meta: { title: "反馈列表" },
    component: require("business/platformManagement/feedbackManagement/goldIdeaList/list.vue").default
  }
];
